export const siteFeaturesKeys = {
  showActiveTransporterBanner: 180044,
  showSafetyBanner: 174098,
  showReadyForEtrnBanner: 220856,
  showAvgPriceBanner: 226883,
};
